import videojs from 'video.js';
import SimpleStateMachine from '../../util/simple-state-machine.js';

const Plugin = videojs.getPlugin('plugin');

const DEFAULT_SESSION_TIMEOUT = 20 * 60 * 1000;




class InactivityPlugin extends Plugin {

    #sessionTimeout = DEFAULT_SESSION_TIMEOUT;

    #stateMachine;
    #inactiveStartTime = Date.now();
    #inactiveCheckingIntervalId;


    constructor(player, options) {
        super(player, options);

        const states = this.#makeStates(
            this.#log.bind(this),
            this.#changeState.bind(this),
            this.#beginInactiveChecking.bind(this),
            this.#stopInactiveChecking.bind(this),
            this.#doReload.bind(this),
            this.#isLivePlayback.bind(this)
        );
        this.#stateMachine = new SimpleStateMachine(states, 'inactive');

        player.ready(() => {
            player.on('play', this.#handlePlay.bind(this));
            player.on('pause', this.#handlePause.bind(this));
            player.on('seeking', this.#handleSeeking.bind(this));
            player.on('ended', this.#handleEnded.bind(this));
        });
    }

    get sessionTimeout() {
        return this.#sessionTimeout;
    }

    set sessionTimeout(milliseconds) {
        this.#sessionTimeout = milliseconds;
    }

    #makeStates(log, changeState, beginInactiveChecking, stopInactiveChecking, doReload, isLivePlayback) {

        const states = {
            active: {
                onEnter: function () {},
                onExit: function () {},

                handlePlay: function () {},
                handleSeeking: function () {},
                handlePause: function () {
                    changeState('inactive');
                },
                handleEnded: function () {
                    changeState('inactive');
                },
                handleInactivityExceeded: function () {}
            },
            inactive: {
                onEnter: function () {
                    beginInactiveChecking();
                },
                onExit: function () {
                    stopInactiveChecking();
                },

                handlePlay: function () {
                    changeState('active');
                },
                handleSeeking: function () {
                    changeState('inactive');
                },
                handlePause: function () {},
                handleEnded: function () {},
                handleInactivityExceeded: function () {
                    changeState('dead');
                }
            },
            dead: {
                onEnter: function () {
                    log('Inactivity threshold exceeded.');
                    if (isLivePlayback()) {
                        doReload();
                    }
                },
                onExit: function () {},

                handlePlay: function () {
                    doReload();
                },
                handleSeeking: function () {
                    doReload();
                },
                handlePause: function () {},
                handleEnded: function () {},
                handleInactivityExceeded: function () {}
            }
        };

        return states;
    }

    #handlePlay() {
        this.#stateMachine.currentState.handlePlay();
    }

    #handlePause() {
        this.#stateMachine.currentState.handlePause();
    }

    #handleSeeking() {
        this.#stateMachine.currentState.handleSeeking();
    }

    #handleEnded() {
        this.#stateMachine.currentState.handleEnded();
    }


    #log(message) {
        this.player.log(message);
    }

    #changeState(toStateName) {
        this.#stateMachine.changeState(toStateName);
    }

    #beginInactiveChecking() {
        clearInterval(this.#inactiveCheckingIntervalId);
        this.#inactiveStartTime = Date.now();
        this.#inactiveCheckingIntervalId = setInterval(this.#inactivityExceededCheck.bind(this), 1000);
    }

    #stopInactiveChecking() {
        clearInterval(this.#inactiveCheckingIntervalId);
    }

    #isLivePlayback() {
        return this.player.usingPlugin('live');
    }

    #doReload() {
        // Reloading the page is not really compatible with directly with 
        // player's use in contexts outside of MVP's player page.
        // TODO: Reload the player/presentation without reloading the page.
        window.location.reload();
    }


    #inactivityExceededCheck() {
        const now = Date.now();
        if (now > this.#inactiveStartTime + this.sessionTimeout) {
            this.#stateMachine.currentState.handleInactivityExceeded();
        }
    }

}

export default InactivityPlugin;